import * as React from 'react';
import LoadingOverlay from '../../shared/loading_overlay';

/* eslint-disable jsx-a11y/heading-has-content */

export default () => (
  <div className="digital-listing-page products show">
    <div className="site-wrapper site-wrapper--narrow">
      <div
        className="digital-listing-page products loading-placeholder-content show"
        data-listing-loading-placeholder=""
      >
        <div className="navigation-breadcrumbs">
          <div className="heading-1 placeholder-h1 quarter-width" />
        </div>
        <section className="mt-2 mb-1 page-header">
          <h1 className="heading-1 product-title placeholder-h1" />
          <div className="horizontal-nav" />
          <div className="g-container mt-half">
            <div className="g-col-2">
              <div className="placeholder-p" />
            </div>
          </div>
        </section>
        <div className="g-container">
          <div className="g-col-8 g-col-mobile-12">
            <LoadingOverlay showOverlay>
              <div className="mb-2 module muted placeholder-gallery" />
            </LoadingOverlay>
            <div className="description-section show-only-on-desktop" />
          </div>
          <div className="g-col-4 g-col-mobile-12">
            <section className="mb-1">
              <div className="module btm-square-module bd-rounded">
                <h1 className="heading-1 margined-bottom placeholder-h1 align-center mt-half mb-1" />
                <div className="btn btn-primary download-btn btn-disabled wide">
                  &nbsp;
                </div>
                <div className="placeholder-p mt-1" />
              </div>
              <div className="module module-footer">
                <div className="placeholder-p" />
              </div>
            </section>
            <section className="mb-1">
              <div className="module btm-square-module bd-rounded">
                <div className="placeholder-p" />
                <div className="placeholder-p mt-1" />
              </div>
              <div className="module module-footer">
                <div className="placeholder-p" />
                <div className="placeholder-p mt-half" />
              </div>
            </section>
            <section className="description-section mb-1 show-only-on-mobile" />
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/show_page/loading_placeholder.jsx